import React, { useState, useCallback } from 'react';

import NodeSelection from '../../NodeSelection/NodeSelection';

const ComponentPlayground = () => {

  const [selection, setSelection] = useState(null);
  const onSelectionChanged = useCallback((newSelection) => {
    setSelection(newSelection);
  }, []);

  return <NodeSelection selection={selection} onSelectionChanged={onSelectionChanged} />;
};

export default ComponentPlayground;
